<section class="invoice-page">
  <split-header-section title="Notas Fiscais"></split-header-section>

  <div class="invoice-page__actions">
    <split-button-card (click)="shippingAccountingVisible = true">
      <div class="flex gap-5 h-full align-items-center">
        <div class="p-3 border-circle bg-orange-50 text-primary">
          <split-icon name="arrow-up-right" size="32"></split-icon>
        </div>
        <split-text
          theme="secondery"
          title="Envios contabilidade"
          subtitle="Adicione as informações de uma nova receita">
        </split-text>
      </div>
    </split-button-card>
  </div>

  <app-invoice-list-container></app-invoice-list-container>
</section>

<p-dialog
  [(visible)]="shippingAccountingVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
  header="Envios para contabilidade"
  styleClass="shipping-accounting-dialog">
  <app-shipping-accounting-container *ngIf="shippingAccountingVisible"></app-shipping-accounting-container>
</p-dialog>

